import { useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';

import { useGlobalization } from '@Translations/useGlobalization';
import { User } from '@Types/user.types';
import { useCreateUserContext } from '../../contexts/CreateUserContext';

import MuiPhoneInput from 'mui-phone-number';
import { useWeaveThemeContext } from '@innovyze/stylovyze';

const StyledPhoneInput = styled(MuiPhoneInput)`
	.MuiPhoneNumber-flagButton {
		min-width: fit-content;
	}
`;

export default function UserPhoneField() {
	const { values, setFieldValue } = useFormikContext<User>();
	const { t } = useGlobalization();
	const blocked = !!values?.blocked;
	const { isWeaveTheme, weaveThemeConsumer } = useWeaveThemeContext();
	const resolvedRoles = weaveThemeConsumer?.resolvedRoles;

	const { userErrors } = useCreateUserContext();
	const { phoneNumber } = values;

	return (
		<StyledPhoneInput
			disabled={blocked}
			defaultCountry={'us'}
			color={'primary'}
			fullWidth
			margin={'normal'}
			label={t('Phone Number')}
			inputProps={{
				style: {
					color:
						isWeaveTheme && resolvedRoles['input.value.fontColor'],
					fontFamily:
						isWeaveTheme && resolvedRoles['input.value.fontFamily'],
				},
			}}
			variant="outlined"
			style={{ marginTop: 8, marginBottom: 8 }}
			name={'phoneNumber'}
			onChange={(
				e:
					| React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
					| string,
			) => {
				let number = e as string;
				if (typeof e === 'object') number = e.target.value;
				if (number == '+') {
					setFieldValue('phoneNumber', '');
					return;
				}
				setFieldValue('phoneNumber', number);
			}}
			value={phoneNumber}
			error={!!userErrors.phoneNumber}
			helperText={userErrors.phoneNumber}
		/>
	);
}
